"use client";

import type { ComponentProps, ReactNode } from "react";

import { Link, usePathname } from "@/i18n/navigation";

type LinkHref = ComponentProps<typeof Link>["href"];

/**
 * Header/footer nav link that lights up to full white on its own page,
 * skips the hover lift (it's already at the brightest tone), and
 * refuses to navigate to itself. Keeps the normal
 * `text-fg-muted → text-fg` interaction off the current route.
 */
const BASE =
  "text-fg-muted hover:text-fg transition-colors aria-[current=page]:text-fg aria-[current=page]:cursor-default";

export function NavLink({
  href,
  className,
  children,
}: {
  href: LinkHref;
  className?: string;
  children: ReactNode;
}) {
  const pathname = usePathname();
  const active = pathname === href;
  return (
    <Link
      href={href}
      aria-current={active ? "page" : undefined}
      onClick={active ? (e) => e.preventDefault() : undefined}
      className={className ? `${BASE} ${className}` : BASE}
    >
      {children}
    </Link>
  );
}
